import { Box, Typography, CircularProgress } from "@mui/material";

export const ChatLoading = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: 2,
        height: "100vh",
      }}
    >
      <CircularProgress size={24} />
      <Typography variant="body1" sx={{ ml: 2 }}>
        Loading...
      </Typography>
    </Box>
  );
};
